import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const allowed = await authService.ensureAuthenticated(state.url);

  if (allowed) {
    return true;
  }

  return authService.authMode() === 'mock'
    ? router.createUrlTree(['/auth/login'])
    : false;
};
